import { Box, Flex, FlexProps } from "@biblioteksentralen/react";
import { CalendarDoorNumber } from "../ChristmasPresent/CalendarDoorNumber";
import { ChristmasPresent, christmasPresentColors } from "../ChristmasPresent/ChristmasPresent";
import { adventDates } from "../utils";

export const animationDurationSeconds = 1.75;

export const animationDelaySeconds = 0.25;

const openingLeftKeyFrames = {
  "@keyframes": {
    "0%": { transform: "perspective(10em) rotateY(0)" },
    "100%": { transform: "perspective(10em) rotateY(-110deg)" },
  },
  animationKey: "openingLeftKeyFrames",
};

const openingRightKeyFrames = {
  "@keyframes": {
    "0%": { transform: "perspective(10em) rotateY(0)" },
    "100%": { transform: "perspective(10em) rotateY(110deg)" },
  },
  animationKey: "openingRightKeyFrames",
};

export const OpeningDoorAnimation = ({ date, ...flexProps }: { date: number } & FlexProps) => {
  const { colorIndex } = adventDates.find(({ date: dateNumber }) => date === dateNumber) ?? {};

  if (!colorIndex) {
    console.error("Something went wrong while opening calendar door", date);
    return null;
  }

  return (
    <Flex overflow="visible" justifyContent="center" alignItems="center" {...flexProps}>
      <Box padding="3rem 0 0" position="absolute" left="50%" transform="translateX(-50%)" overflow="visible">
        <ChristmasPresent
          width={{ base: "6.5rem", md: "7.5rem" }}
          height={{ base: "5.85rem", md: "6.75rem" }} // 90% of width
          {...christmasPresentColors[colorIndex]}
          animationPlayState="running"
          animationKeyFrames={openingLeftKeyFrames}
          animationDuration={`${animationDurationSeconds}s`}
          animationDelay={`${animationDelaySeconds}s`}
          clipPath="inset(-50% 50% 0 0)"
          transformOrigin="0"
        >
          <CalendarDoorNumber date={date} width="2.75rem" height="2.75rem" fontSize="2xl" />
        </ChristmasPresent>
      </Box>
      <Box padding="3rem 0 0" position="absolute" left="50%" transform="translateX(-50%)">
        <ChristmasPresent
          width={{ base: "6.5rem", md: "7.5rem" }}
          height={{ base: "5.85rem", md: "6.75rem" }} // 90% of width
          {...christmasPresentColors[colorIndex]}
          animationPlayState="running"
          animationKeyFrames={openingRightKeyFrames}
          animationDuration={`${animationDurationSeconds}s`}
          animationDelay={`${animationDelaySeconds}s`}
          clipPath="inset(-50% 0 0 50%)"
          transformOrigin="100%"
        >
          <CalendarDoorNumber date={date} width="2.75rem" height="2.75rem" fontSize="2xl" />
        </ChristmasPresent>
      </Box>
    </Flex>
  );
};
